import {
    DEALERGETSUMMARYMASTERLIST_SUCCESS,
    DEALERGETSUMMARYMASTERLIST_FAILED,
    RESET_DEALERGETSUMMARYMASTERLIST,
    LOADING_DEALERGETSUMMARYMASTERLIST,
    NETWORK_ERROR_DEALERGETSUMMARYMASTERLIST
} from '../types/index'
import { dealerServices } from "../../config/axios";


const resetDealerGetSummaryMasterList = () => {
    return { type: RESET_DEALERGETSUMMARYMASTERLIST };
};

const dealerGetSummaryMasterList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERGETSUMMARYMASTERLIST });
    await dealerServices
        .post("getSummaryMasterList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerGetSummaryMasterListsuccess(res.data));
                    break;
                default:
                    dispatch(dealerGetSummaryMasterListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERGETSUMMARYMASTERLIST,
                payload: err
            });
        });
}


function dealerGetSummaryMasterListsuccess(data) {
    return {
        type: DEALERGETSUMMARYMASTERLIST_SUCCESS,
        payload: data
    };
}

function dealerGetSummaryMasterListFailed(data) {
    return {
        type: DEALERGETSUMMARYMASTERLIST_FAILED,
        payload: data
    };
}


export { resetDealerGetSummaryMasterList, dealerGetSummaryMasterList }